import ISuppliesRepository from '../domain/ISuppliesRepository';
import suppliesRepository from '../infrastructure/repositories/SuppliesRepository';

class DownloadSuppliesService {
  private readonly _suppliesRepository: ISuppliesRepository;

  constructor({ suppliesRepository }) {
    this._suppliesRepository = suppliesRepository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._suppliesRepository.downloadSupplies({
      queryParams
    });
  }
}

export default new DownloadSuppliesService({
  suppliesRepository: suppliesRepository
});

export { DownloadSuppliesService };
